import type { JSX } from 'react';
import {
    TomSynchronizationStatus,
    TomSyncReason,
} from 'dg-web-shared/model/Tom.ts';
import {
    Translation,
    TranslationWithArgs1,
    TranslationWithArgs2,
} from '../../common/i18n/Text.ts';
import { OperatorBadge } from './OperatorBadge.tsx';

export interface TomSyncStatusTexts {
    CurrentSynchronizationStatus: Translation;
    SynchronizationStatus: TranslationWithArgs1<TomSynchronizationStatus>;
    InSync: Translation;
    NeedsUpdate: Translation;
    Updating: Translation;
    Error: Translation;
    Reason: Translation;
    NewConfiguration: Translation;
    OutOfSpecialDays: Translation;
    OutOfHolidays: Translation;
    NotAllConfigsOnTom: Translation;
    NextUpdateNecessary: Translation;
    NoUpdateNeeded: Translation;
    UpdateBefore: TranslationWithArgs1<string>;
    ConfigurationExpiryValue: TranslationWithArgs1<string>;

    SyncUntil: TranslationWithArgs1<string>;
    SyncReason: Translation;
    SyncReasonValue: TranslationWithArgs1<TomSyncReason>;
    SyncReasonNewTomConfig: Translation;
    SyncReasonNewZoneConfig: Translation;
    SyncReasonOutOfSpecialDays: Translation;
    SyncReasonOutOfHolidays: Translation;
    SyncReasonNotAllConfigsSynced: Translation;

    SyncReasonUntil: TranslationWithArgs2<TomSyncReason, string>;
    SyncReasonNewTomConfigUntil: TranslationWithArgs1<string>;
    SyncReasonNewZoneConfigUntil: TranslationWithArgs1<string>;
    SyncReasonOutOfSpecialDaysUntil: TranslationWithArgs1<string>;
    SyncReasonOutOfHolidaysUntil: TranslationWithArgs1<string>;
    SyncReasonNotAllConfigsSyncedUntil: TranslationWithArgs1<string>;
}

export function TomSyncStatus(props: {
    status: TomSynchronizationStatus;
}): JSX.Element {
    return (
        <OperatorBadge
            circular
            empty
            color={
                props.status === 'in_sync'
                    ? 'green'
                    : props.status === 'updating'
                      ? 'yellow'
                      : 'red'
            }
        />
    );
}
